import React, { useState } from "react";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import DailyForecast from "./DailyForecast";
import "bootstrap/dist/css/bootstrap.css";
import CodedInfo from "./CodedInfo";
import axios from "axios";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      city: response.data.city,
      country: response.data.country,
      temperature: response.data.temperature.current,
      description: response.data.condition.description,
      icon: response.data.condition.icon,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      date: new Date(response.data.time * 1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleUpdateCity(event) {
    setCity(event.target.value);
  }

  function search() {
    let apiKey = "441fcacb9dt020b37114da0ba3e3f5of";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <input
            type="search"
            onChange={handleUpdateCity}
            placeholder="Enter a city"
          />
          <input type="submit" value="Search" />
        </form>
        <WeatherInfo data={weatherData} />
        <DailyForecast city={weatherData.city} />
        <CodedInfo />
      </div>
    );
  } else {
    search();
    return null;
  }
}
